import { combineReducers } from 'redux';

import category from './category';
import filter from './filter';
import search from './search';
import productList from './product-list';

export default combineReducers({
  category,
  filter,
  search,
  productList,
});
